import Component from '../classes/Component';
import { getOffset, mapRange } from '../utils';

export default class Billboard extends Component {
	constructor({ element }) {
		super({
			element,
		});

		this.activeGrid = document.querySelector('.c-dot-grid.active');
		this.scrollCache = 0;
		this.loopInterval = null;
		this.position = getOffset(element, window.scrollY);
		this.target = null;

		this.createObserver();
		this.update();
	}

	createObserver() {
		this.observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					this.target = entry.target;
					const hasPinkDots = this.target.dataset.billboard === 'pink';
					if (hasPinkDots) {
						this.activeGrid.setAttribute('style', '--dot-color: #92278F');
					} else {
						this.activeGrid.setAttribute('style', '--dot-color: #642D91');
					}
				} else {
					this.activeGrid.classList.remove('visible');
					this.target = null;
				}
			});
		});

		this.observer.observe(this.element);
	}

	update() {
		if (this.target) {
			const scrollProgress = mapRange(this.position.top - window.innerHeight, this.position.bottom, 0, 100, window.scrollY);
			const scrollOffset = 50;
			const isCached = scrollProgress === this.scrollCache;

			if (!isCached) {
				if (scrollProgress > scrollOffset) {
					const value = (scrollProgress - scrollOffset) * 2;
					if (value > 20) {
						this.activeGrid.classList.remove('visible');
					}
				} else {
					this.activeGrid.classList.add('visible');
				}
			}

			this.scrollCache = scrollProgress;
		}
	}
}
